import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

// Inbox plus is enabled in the UI when the user configuration InboxPlusTabs property is set. We
// need this to be set on the server so we guarantee the correct items are being sent in sessiondata
export function isInboxPlusEnabled(): boolean {
    return isInInboxPlusTreatment() && getUserConfiguration().UserOptions.InboxPlusTabs !== null;
}

export function isInInboxPlusTreatment(): boolean {
    return isFeatureEnabled('tri-inboxPlusDefaultTabs');
}

export function isInInboxPlusDefaultTabsExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
        isFeatureEnabled('tri-inboxPlusDefaultTabsControl')
    );
}
